import React from 'react';

import styled from 'styled-components';

import RingCentralRecordsControls from './RingCentralRecordsControls';
import RingCentralRecordsTable from './RingCentralRecordsTable';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 10px 30px;
`;

const RingCentralRecordsData = () => {
  return (
    <Container>
      <RingCentralRecordsControls />
      <RingCentralRecordsTable />
    </Container>
  );
};

export default RingCentralRecordsData;
